import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { PROJECT } from '../constants';
import firebase from '../lib/firebase';

const initUser = localStorage.getItem(`${PROJECT}:user`);
const initJWT = localStorage.getItem(`${PROJECT}:jwt`);

const INIT_STATE = {
  logged: !!initJWT,
  user: typeof initUser === 'string' ? JSON.parse(initUser) : (initUser || {}),
  jwt: initJWT
};

const Auth = createContext(INIT_STATE);

function Provider({ children }) {
  const [state, setState] = useState(INIT_STATE);

  const actions = {
    initAuth: ({ jwt, user }) => {
      localStorage.setItem(`${PROJECT}:jwt`, jwt);
      localStorage.setItem(`${PROJECT}:user`, JSON.stringify(user));

      setState({ loggedIn: true, jwt, user });
    },
    updateAuth: (update) => {
      if (update.user) localStorage.setItem(`${PROJECT}:user`, JSON.stringify(update.user));

      setState({ loggedIn: true, ...state, ...update });
    },
    logout: async ({ jwt, user }) => {
      localStorage.removeItem(`${PROJECT}:jwt`);
      localStorage.removeItem(`${PROJECT}:user`);
      await firebase.signOut();

      setState({ loggedIn: false, jwt: null, user: {} });
    },
  };

  const value = {
    state,
    actions,
  };

  return <Auth.Provider value={value}>{children}</Auth.Provider>;
}

Provider.propTypes = {
  children: PropTypes.node,
};

export const withAuthContext = WrappedComponent =>
  function Wrapper() {
    return (
      <Provider>
        <WrappedComponent />
      </Provider>
    );
  };

export const useAuthContext = () => useContext(Auth);